import {
  FETCH_BROKERS_REQUEST,
  FETCH_BROKERS_SUCCESS,
  FETCH_BROKERS_FAILURE,
  FETCH_BROKERS_LIST_REQUEST,
  FETCH_BROKERS_LIST_SUCCESS,
  FETCH_BROKERS_LIST_FAILURE,
  FETCH_BROKER_BY_ID_REQUEST,
  FETCH_BROKER_BY_ID_SUCCESS,
  FETCH_BROKER_BY_ID_FAILURE,
  CLEAR_BROKER_BY_ID,
  BROKER_UPDATE_CONFIG,
  BROKER_DELETE_REQUEST,
  BROKER_EANBLE_REQUEST,
} from '../constants/ActionTypes';

import {
  getIsBrokersFetching,
  getIsSelectedBrokerFetching,
  getIsBrokersListFetching,
} from '../reducers';
import { brokers, setAuthorizationHeader } from '../api';
import storage from '../storage';

import { timeoutPromise } from '../helpers/promises';

export const fetchBrokers = () => async (dispatch, getState) => {
  try {
    if (getIsBrokersFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    dispatch({
      type: FETCH_BROKERS_REQUEST,
    });

    const data = await brokers.getBrokers();

    dispatch({
      type: FETCH_BROKERS_SUCCESS,
      data,
    });

    await timeoutPromise(200);

    return Promise.resolve();
  } catch (error) {
    let message = 'Undfined Error';

    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      message = error.response.data.message;
    } else if (error.message) {
      message = error.message;
    }

    dispatch({
      type: FETCH_BROKERS_FAILURE,
      message,
    });

    return Promise.reject(message);
  }
};

export const fetchBrokersList = () => (dispatch, getState) => {
  if (getIsBrokersListFetching(getState())) {
    return Promise.resolve();
  }

  setAuthorizationHeader(storage.getItem('token'));

  dispatch({
    type: FETCH_BROKERS_LIST_REQUEST,
  });

  return brokers
    .getBrokersList()
    .then((data) =>
      dispatch({
        type: FETCH_BROKERS_LIST_SUCCESS,
        data,
      })
    )
    .catch((error) => {
      let message = 'Undfined Error';

      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }
      return dispatch({
        type: FETCH_BROKERS_LIST_FAILURE,
        message,
      });
    });
};

const findBrokerByBrokerName = (res, findid) => {
  const broker = res.data.data;

  return broker.filter(({ name }) => name === findid)
    ? broker.filter(({ name }) => name === findid)[
        broker.filter(({ name }) => name === findid).length - 1
      ]
    : null;
};

export const fetchBrokerByBrokerName = (id) => (dispatch, getState) => {
  if (getIsSelectedBrokerFetching(getState())) {
    return Promise.resolve();
  }

  setAuthorizationHeader(storage.getItem('token'));

  dispatch({
    type: FETCH_BROKER_BY_ID_REQUEST,
  });

  return brokers
    .getBrokers()
    .then((data) => findBrokerByBrokerName(data, id))
    .then((data) => {
      if (data === null) {
        return dispatch({
          type: FETCH_BROKER_BY_ID_FAILURE,
          message: 'null',
        });
      }

      return dispatch({
        type: FETCH_BROKER_BY_ID_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      let message = 'Undfined Error';

      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }
      return dispatch({
        type: FETCH_BROKER_BY_ID_FAILURE,
        message,
      });
    });
};

const findBrokerById = (res, findid) => {
  const broker = res.data.data;

  return broker.find(({ id }) => id === findid) || null;
};

export const fetchBrokerById = (id) => (dispatch, getState) => {
  if (getIsSelectedBrokerFetching(getState())) {
    return Promise.resolve();
  }

  setAuthorizationHeader(storage.getItem('token'));

  dispatch({
    type: FETCH_BROKER_BY_ID_REQUEST,
  });

  return brokers
    .getBrokers()
    .then((data) => findBrokerById(data, id))
    .then((data) => {
      if (data === null) {
        return dispatch({
          type: FETCH_BROKER_BY_ID_FAILURE,
          message: 'null',
        });
      }

      return dispatch({
        type: FETCH_BROKER_BY_ID_SUCCESS,
        data,
      });
    })
    .catch((error) => {
      let message = 'Undfined Error';

      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }
      return dispatch({
        type: FETCH_BROKER_BY_ID_FAILURE,
        message,
      });
    });
};

export const clearBrokerById = () => (dispatch) => {
  dispatch({
    type: CLEAR_BROKER_BY_ID,
  });

  return Promise.resolve('');
};

export const updateBrokerConfig = (data) => (dispatch) => {
  dispatch({
    type: BROKER_UPDATE_CONFIG,
    data,
  });

  return Promise.resolve();
};

export const removeBroker = (id) => (dispatch) => {
  dispatch({
    type: BROKER_DELETE_REQUEST,
  });

  setAuthorizationHeader(storage.getItem('token'));

  return brokers.removeBroker(id);
};

export const enableBroker = (id) => (dispatch) => {
  dispatch({
    type: BROKER_EANBLE_REQUEST,
  });

  setAuthorizationHeader(storage.getItem('token'));

  return brokers.enableBroker(id);
};

export const loginNullBroker = () => () => {
  return Promise.resolve();
};
